import { TimeZone } from 'common/Constants';
import { useConsumerExploreDishFirstZipCodeQuery } from 'src/gqlReactTypings.generated.d';

export const useConsumerExploreDishFirstZipCode = (zipCode?: string | null) => {
  const { data: zipCodeQueryData, loading: isZipCodeLoading } = useConsumerExploreDishFirstZipCodeQuery({
    variables: { zipCode: zipCode ?? '' },
    fetchPolicy: 'cache-first',
  });
  const timeZone = zipCodeQueryData?.zipCode?.timeZone ?? TimeZone.LosAngeles;

  return { isZipCodeLoading, timeZone, zipCodeQueryData };
};
